_N_E =
(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[24],{

/***/ "KtBH":
/***/ (function(module, exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/my-account",
      function () {
        return __webpack_require__("Y6tn");
      }
    ]);
  

/***/ }),

/***/ "Y6tn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("rePB");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__("ODXe");

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__("nKUr");

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__("q1tI");

// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__("mOvS");
var config_default = /*#__PURE__*/__webpack_require__.n(config);

// EXTERNAL MODULE: ./node_modules/@grandvision/auth/dist/index.es.js
var index_es = __webpack_require__("9wPQ");

// EXTERNAL MODULE: ./node_modules/@grandvision/bloomreach/dist/index.es.js + 4 modules
var dist_index_es = __webpack_require__("cIxt");

// EXTERNAL MODULE: ./node_modules/@grandvision/state/dist/index.es.js
var state_dist_index_es = __webpack_require__("k3MI");

// EXTERNAL MODULE: ./components/forms/Address.tsx
var Address = __webpack_require__("gGus");

// EXTERNAL MODULE: ./components/summaries/Address.tsx
var summaries_Address = __webpack_require__("GGR6");

// EXTERNAL MODULE: ./node_modules/@grandvision/forms/dist/index.es.js + 8 modules
var forms_dist_index_es = __webpack_require__("wE1k");

// EXTERNAL MODULE: ./components/forms/controls/index.ts + 12 modules
var controls = __webpack_require__("kAEV");

// CONCATENATED MODULE: ./components/forms/PersonalDetails.tsx






var PersonalDetails_PersonalDetailsForm = function PersonalDetailsForm() {
  return /*#__PURE__*/Object(jsx_runtime["jsxs"])(forms_dist_index_es["l" /* FormGroup */], {
    children: [/*#__PURE__*/Object(jsx_runtime["jsx"])(controls["f" /* FirstName */], {}), /*#__PURE__*/Object(jsx_runtime["jsx"])(controls["g" /* LastName */], {}), /*#__PURE__*/Object(jsx_runtime["jsx"])(controls["d" /* DateOfBirth */], {}), /*#__PURE__*/Object(jsx_runtime["jsx"])(controls["h" /* PhoneNumber */], {})]
  });
};

/* harmony default export */ var PersonalDetails = (PersonalDetails_PersonalDetailsForm);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/format/index.js + 31 modules
var format = __webpack_require__("sWYD");

// EXTERNAL MODULE: ./node_modules/@grandvision/common/dist/index.es.js
var common_dist_index_es = __webpack_require__("ytpp");

// CONCATENATED MODULE: ./components/summaries/PersonalDetails.tsx





var PersonalDetails_PersonalDetailsSummary = function PersonalDetailsSummary(_ref) {
  var data = _ref.data,
      email = _ref.email;
  var formattedDate = data.customerDateOfBirth && Object(format["a" /* default */])(new Date(data.customerDateOfBirth.replace(/-/g, '/')), 'dd / MM / yyyy');
  return /*#__PURE__*/Object(jsx_runtime["jsxs"])("p", {
    children: [Object(common_dist_index_es["mb" /* SummaryItem */])([data.firstName, data.lastName]), Object(common_dist_index_es["mb" /* SummaryItem */])(formattedDate), Object(common_dist_index_es["mb" /* SummaryItem */])(data.phone), Object(common_dist_index_es["mb" /* SummaryItem */])(email)]
  });
};

/* harmony default export */ var summaries_PersonalDetails = (PersonalDetails_PersonalDetailsSummary);
// EXTERNAL MODULE: ./util/feature-toggle.ts
var feature_toggle = __webpack_require__("ns9e");

// CONCATENATED MODULE: ./pages/my-account.tsx





function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }












var _getConfig = config_default()(),
    publicRuntimeConfig = _getConfig.publicRuntimeConfig;

var staticsUrl = publicRuntimeConfig.grandvision.staticsUrl || '';
var featureToggles = Object.entries({
  isAddressBookEnabled: feature_toggle["b" /* isAddressBookEnabled */],
  isSubscriptionUpdateAddressEnabled: feature_toggle["p" /* isSubscriptionUpdateAddressEnabled */],
  isSubscriptionHasOneAddressEnabled: feature_toggle["o" /* isSubscriptionHasOneAddressEnabled */]
}).reduce(function (result, _ref) {
  var _ref2 = Object(slicedToArray["a" /* default */])(_ref, 2),
      key = _ref2[0],
      fn = _ref2[1];

  return _objectSpread(_objectSpread({}, result), {}, Object(defineProperty["a" /* default */])({}, key, fn()));
}, {});
var richText = "\n  <h4>No account yet?</h4>\n  <p style=\"margin-bottom: 1rem;\">Create an account to manage your eyecare with Vision Express.</p>\n  <ul class=\"checkmark-list\">\n    <li>See your prescription.</li>\n    <li>View and change your contact lens plan.</li>\n    <li>Top up contact lenses.</li>\n    <li>View your order history.</li>\n    <li>Express re-order.</li>\n  </ul>\n";

var my_account_MyAccount = function MyAccount(_ref3) {
  var currentRoute = _ref3.currentRoute;

  var _useIntl = Object(state_dist_index_es["Q" /* useIntl */])(),
      getLabel = _useIntl.getLabel,
      locale = _useIntl.locale,
      country = _useIntl.country;

  var consent = [{
    title: getLabel('account.consent.adult'),
    value: 'adult'
  }, {
    title: getLabel('account.consent.message'),
    value: 'terms'
  }];
  return /*#__PURE__*/Object(jsx_runtime["jsxs"])(dist_index_es["d" /* CmsContainerPage */], {
    children: [/*#__PURE__*/Object(jsx_runtime["jsx"])(dist_index_es["f" /* CmsHeadTags */], {
      title: "My Account",
      noIndex: true,
      noFollow: true
    }), /*#__PURE__*/Object(jsx_runtime["jsx"])(dist_index_es["g" /* CmsPageLayout */], {
      children: /*#__PURE__*/Object(jsx_runtime["jsxs"])(index_es["h" /* MyAccountRoot */], _objectSpread(_objectSpread({
        locale: locale,
        country: country,
        initialRoute: currentRoute,
        consentItems: consent,
        createAccountRichText: richText,
        staticsUrl: staticsUrl
      }, featureToggles), {}, {
        children: [/*#__PURE__*/Object(jsx_runtime["jsx"])(index_es["h" /* MyAccountRoot */].PersonalDetailsFields, {
          children: /*#__PURE__*/Object(jsx_runtime["jsx"])(PersonalDetails, {})
        }), /*#__PURE__*/Object(jsx_runtime["jsx"])(index_es["h" /* MyAccountRoot */].AddressFields, {
          children: /*#__PURE__*/Object(jsx_runtime["jsx"])(Address["a" /* default */], {
            type: "billingAddress"
          })
        }), /*#__PURE__*/Object(jsx_runtime["jsx"])(index_es["h" /* MyAccountRoot */].PersonalDetailsSummary, {
          children: function children(_ref4) {
            var data = _ref4.data,
                email = _ref4.email;
            return /*#__PURE__*/Object(jsx_runtime["jsx"])(summaries_PersonalDetails, {
              data: data,
              email: email
            });
          }
        }), /*#__PURE__*/Object(jsx_runtime["jsx"])(index_es["h" /* MyAccountRoot */].AddressSummary, {
          children: function children(_ref5, title) {
            var data = _ref5.data;
            return /*#__PURE__*/Object(jsx_runtime["jsx"])(summaries_Address["a" /* default */], {
              type: "billingAddress",
              values: data,
              title: title
            });
          }
        })]
      }))
    })]
  });
};

my_account_MyAccount.getInitialProps = function (_ref6) {
  var _req$params;

  var req = _ref6.req;
  return {
    currentRoute: (_req$params = req.params) === null || _req$params === void 0 ? void 0 : _req$params.currentRoute
  };
};

/* harmony default export */ var my_account = __webpack_exports__["default"] = (my_account_MyAccount);

/***/ }),

/***/ "mOvS":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("yLiY")


/***/ })

},[["KtBH",1,2,4,6,5,3,0,13]]]);